import { useState } from 'react';
import { getCuposPractica } from '../../../services/Afiliado/CupoPractica';

export const useValidarCupoPractica = () => {
  const [isPracticasSinCupo, setIsPracticasSinCupo] = useState(false);
  const [practicasCupo, setPracticasCupo] = useState([]);

  const validarCupoPractica = async ({ idAfiliado, practica, fechaInicio, practicasCargadas }) => {
    const cuposPracticas = await getCuposPractica({
      idAfiliado,
      practicas: [practica],
      fechaInicio,
    });

    if (cuposPracticas) {
      const newPracticaCupo = practicasCargadas.find(
        (item) => item?.practica?.idPractica === practica?.idPractica,
      );
      newPracticaCupo.practicaSinCupo = cuposPracticas.practicasSinCupo || false;
      const newPracticasCupo = [...practicasCupo, newPracticaCupo];
      updateIsPracticaSinCupo(newPracticasCupo);
      setPracticasCupo(newPracticasCupo);
    }
  };

  const updateIsPracticaSinCupo = (practicasCupo) => {
    const isPracticaSinCupo = practicasCupo.some((item) => item.practicaSinCupo === true);
    setIsPracticasSinCupo(isPracticaSinCupo);
  };

  const deletePracticaCupo = (practica = []) => {
    if (practica.length === 0) {
      setPracticasCupo([]);
      setIsPracticasSinCupo(false);
      return;
    }

    const updatedPracticaCupo = practicasCupo.filter(
      (item) => item?.practica?.idPractica !== practica?.idPractica,
    );
    updateIsPracticaSinCupo(updatedPracticaCupo);
    setPracticasCupo(updatedPracticaCupo);

    if (updatedPracticaCupo.length === 0) {
      setIsPracticasSinCupo(false);
    }
  };

  return {
    isPracticasSinCupo: isPracticasSinCupo,
    deletePracticaCupo,
    validarCupoPractica,
  };
};
